<template>
  <div>
    <div class="pointer" @click="dialog = true">
      <div v-if="showSummary">
        <div v-if="summaryText.any"><b>Any Material</b></div>
        <div v-else-if="summaryText.unknown">
          <b>Material Options:</b> Unknown
        </div>
        <div v-else>
          <div
            v-if="summaryText.companies && summaryText.companies.length"
            class="my-2"
          >
            <b>All materials from:</b>
            <ul>
              <li
                v-for="companyName in summaryText.companies"
                :key="companyName"
                v-html="companyName"
              ></li>
            </ul>
          </div>
          <div
            v-if="summaryText.materials && summaryText.materials.length"
            class="my-2"
          >
            <b>Materials:</b>
            <ul>
              <li
                v-for="materials in summaryText.materials"
                :key="materials"
                v-html="materials"
              ></li>
            </ul>
          </div>
        </div>
      </div>
      <v-btn text small color="primary"
        ><v-icon small color="primary" class="mr-1">mdi-pencil</v-icon>
        {{ buttonLabel }}</v-btn
      >
    </div>

    <v-dialog v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          GP Material Selector
          <v-checkbox
            v-model="any"
            label="Any/All Materials"
            class="mx-4"
          ></v-checkbox>
        </v-card-title>

        <v-card-text class="pa-4">
          <div v-if="materials">
            <div
              v-for="(materialArr, companyId) in materialsByCompany"
              :key="companyId"
              class="px-2 pb-4"
            >
              <div
                :class="{
                  highlighted: selectedCompanies.includes(companyId) || any,
                }"
              >
                <div
                  class="font-weight-bold sectionHeader px-2"
                  :class="{ pointer: !any }"
                  @click="toggleCompany(companyId)"
                >
                  <span v-if="materialCompanies[companyId]">
                    <v-icon class="mr-2"
                      >mdi-checkbox{{
                        selectedCompanies.includes(companyId) || any
                          ? ""
                          : "-blank"
                      }}-outline</v-icon
                    >

                    {{ materialCompanies[companyId].name }}</span
                  >
                  <span v-else class="ml-6">Other</span>
                </div>
                <v-divider class="mb-1"></v-divider>
                <div class="d-flex flex-row flex-wrap align-start ml-2">
                  <div
                    v-for="materialId in materialArr"
                    :key="materialId"
                    class="mr-4 itemClass d-flex flex-row align-start"
                    :class="{
                      highlighted: selectedMaterials.includes(materialId),
                      pointer: !selectedCompanies.includes(companyId) && !any,
                    }"
                    @click="toggleMaterial(materialId)"
                  >
                    <v-icon class="mr-2"
                      >mdi-checkbox{{
                        selectedMaterials.includes(materialId) ||
                        selectedCompanies.includes(companyId) ||
                        any
                          ? ""
                          : "-blank"
                      }}-outline</v-icon
                    >
                    {{ materials[materialId].name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            text
            color="red"
            @click="
              selectedMaterials = [];
              selectedCompanies = [];
              any = false;
            "
            >Unselect All</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Cancel </v-btn>
          <v-btn color="green" text @click="doSave()"> Accept </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "RgpMaterialPicker",
  props: {
    materialCompanies: null,
    materials: null,
    materialsByCompany: null,
    external: null,
    showSummary: { type: Boolean, default: true },
    buttonLabel: { type: String, default: "Choose/Edit Materials" },
  },
  data: function () {
    return {
      dialog: false,
      selectedMaterials: [],
      selectedCompanies: [],
      any: false,
    };
  },
  methods: {
    toggleMaterial(id) {
      //   console.log(id);
      let index = this.selectedMaterials.indexOf(id);
      if (index > -1) {
        this.selectedMaterials.splice(index, 1);
      } else {
        this.selectedMaterials.push(id);
      }
    },
    toggleCompany(id) {
      //   console.log(id);
      let index = this.selectedCompanies.indexOf(id);
      if (index > -1) {
        this.selectedCompanies.splice(index, 1);
      } else {
        this.selectedCompanies.push(id);
      }
    },
    setFromExternal(obj) {
      if (obj.any) this.any = obj.any;
      if (obj.companies) this.selectedCompanies = obj.companies;
      if (obj.materials) this.selectedMaterials = obj.materials;
    },
    doSave() {
      this.$emit("change", this.summary);
      this.dialog = false;
    },
  },
  computed: {
    summary: function () {
      let rtn = { companies: [], materials: [], anyMaterial: this.any };
      if (this.any) return rtn;
      rtn.companies = this.selectedCompanies;

      let that = this;
      this.selectedMaterials.forEach((id) => {
        const mObj = that.materials[id];
        const compId = mObj.companyId;
        if (!rtn.companies.includes(compId)) rtn.materials.push(id);
      });
      return rtn;
    },
    summaryText: function () {
      let any = this.external?.any;
      let materials = this.external?.materials ?? [];
      let companies = this.external?.companies ?? [];

      let rtn = { companies: [], materials: [], any: this.any, unknown: false };
      if (!this.external || any) return rtn;
      let that = this;

      companies.forEach((id) => {
        rtn.companies.push(that.materialCompanies[id].name);
      });

      materials.forEach((id) => {
        rtn.materials.push(that.materials[id].name);
      });

      if (!any && !materials.length && !companies.length) rtn.unknown = true;

      return rtn;
    },
  },
  watch: {
    external: {
      handler: function (val) {
        this.setFromExternal(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.external) this.setFromExternal(this.external);
  },
};
</script>

<style scoped>
.itemClass {
  width: 180px;
}
.highlighted {
  background-color: #e5f5ff;
}
.sectionHeader {
  padding: 2px;
  background-color: #b5e2ff;
}
</style>
